import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { Chip } from '#pplx/frontend/aether/components/Chip/index.js';
import { Tooltip } from '#pplx/frontend/aether/components/Tooltip/index.js';
import { getSearchModeLabel } from '#pplx/frontend/apps/ask/search-modes/core/search-modes-names.js';
import { getSearchModeIcon } from '#pplx/frontend/ask-models/types/search-modes.js';
import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useIsMobileStyle } from '#pplx/frontend/platform-components/useMobileStyle.js';
import { memo, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
const searchModeChipClearedEvent = EVENT_PAYLOAD;
export const AskInputSearchMode = memo(function AskInputSearchMode({ searchMode, onClearSearchMode, clearable = true, disabled = false, disabledTooltip, }) {
    const isSidecar = !!import.meta.env.VITE_IS_SIDECAR_BUILD;
    const isMobileStyle = useIsMobileStyle();
    const icon = getSearchModeIcon(searchMode);
    const { $t } = useIntl();
    const label = getSearchModeLabel(searchMode);
    const { track } = useInstrumentation();
    const handleClearSearchMode = useCallback(() => {
        if (!clearable) {
            return;
        }
        track(searchModeChipClearedEvent({
            name: 'search mode chip cleared',
            data: { mode: searchMode },
        }));
        onClearSearchMode();
    }, [clearable, track, searchMode, onClearSearchMode]);
    const labelText = $t(label);
    const button = isSidecar || isMobileStyle ? (_jsx(SidecarSearchModeButton, { icon: icon, label: labelText, disabled: disabled, clearable: clearable, onClearSearchMode: handleClearSearchMode })) : clearable ? (_jsx(Chip, { label: labelText, leadingAccessory: icon, variant: "suggestion", rounded: true, disabled: disabled, onClick: handleClearSearchMode, onDelete: handleClearSearchMode, selected: true, interactableVariant: "alt" })) : (_jsx(Chip, { label: labelText, leadingAccessory: icon, variant: "suggestion", rounded: true, disabled: disabled, selected: true, interactableVariant: "alt" }));
    if (disabledTooltip) {
        return (_jsx(Tooltip, { content: disabledTooltip, side: "bottom", children: button }));
    }
    return button;
});
/** Sidecar-only button that swaps the icon to an x on hover. */
function SidecarSearchModeButton({ icon, label, disabled, clearable, onClearSearchMode, }) {
    const [isHovered, setIsHovered] = useState(false);
    const handleMouseEnter = useCallback(() => setIsHovered(true), []);
    const handleMouseLeave = useCallback(() => setIsHovered(false), []);
    const buttonIcon = isHovered && !disabled && clearable ? $icon('x') : icon;
    return (_jsx("div", { onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, className: "inline-flex", children: _jsx(Button, { variant: "tonal", size: "small", rounded: true, icon: buttonIcon, onClick: clearable ? onClearSearchMode : undefined, "aria-label": label, disabled: disabled }) }));
}
//# sourceMappingURL=AskInputSearchMode.js.map